import { c as _c } from "react/compiler-runtime";
import { ReactNode } from 'react';
import { PINNED_RIGHT_EDGE_LINE_STYLE } from '../../../../../../../../constants/borderStyles';
export type ActionColumnCellProps = {
  width: number;
  heightPx: number;
  children: ReactNode;
};

/**
 * Sticky <td> cell for the action column.
 * Owns all layout concerns: sticky positioning, drop shadow, edge line, width constraints,
 * and stopPropagation to prevent row click when interacting with action buttons.
 */
export function ActionColumnCell(props) {
  const $ = _c(7);
  const handleClick = _temp;
  let t0;
  if ($[0] !== props.heightPx || $[1] !== props.width) {
    t0 = {
      position: "sticky",
      right: 0,
      zIndex: "var(--z-sidebar)",
      width: props.width,
      maxWidth: props.width,
      height: props.heightPx,
      maxHeight: props.heightPx
    };
    $[0] = props.heightPx;
    $[1] = props.width;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <span style={PINNED_RIGHT_EDGE_LINE_STYLE} />;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== props.children || $[5] !== t0) {
    t2 = <td className="p-0 border-0 bg-white shadow-[-2px_0_4px_-2px_rgba(0,0,0,0.15)]" style={t0} onClick={handleClick}>{t1}{props.children}</td>;
    $[4] = props.children;
    $[5] = t0;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}
function _temp(event) {
  event.stopPropagation();
}